/**
 * @description
 * 抵扣券相关，调用了抵扣券公共库，以网页窗口展示
 */
import { computed } from "@vue/composition-api"
import { createNamespacedHelpers } from "vuex-composition-helpers"
import * as config from "../../config"
import { AppleGiftCardActions } from "../../store/apple-gift-card/actions"
import { AppleGiftCardGetters } from "../../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../../store/apple-gift-card/mutations"
import { AppleGiftCardState, UsingLocation } from "../../store/apple-gift-card/state"

const { useActions, useState } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  const { availableCoupons, configInfo, selectedCoupon, usingLocation } = useState([
    "availableCoupons",
    "configInfo",
    "selectedCoupon",
    "usingLocation"
  ])

  const { openCouponDialog, setSelectedCoupon, hideCouponDialog, reportUserAction } = useActions([
    "openCouponDialog",
    "setSelectedCoupon",
    "hideCouponDialog",
    "reportUserAction"
  ])
  const isAppleGiftCardLocation = computed(() => usingLocation.value === UsingLocation.APPLE_GIFT_CARD)

  const OpenCoupons = () => {
    if (!isAppleGiftCardLocation.value) {
      reportUserAction({
        iformat: config.REPORT.CLICK[usingLocation.value].COUPON
      })
    }
    const buyColumn: Array<number> = configInfo.value.BUY_COLUMN.map(v => Number(v.num))
    openCouponDialog({
      totalPrice: buyColumn[buyColumn.length - 1],
      events: {
        selectCoupons: selectedCoupon => {
          if (selectedCoupon?.length > 0) {
            const coupon = {
              cardId: selectedCoupon[0].card_id,
              batchId: selectedCoupon[0].batch_id,
              saving: selectedCoupon[0].amt,
              codeId: selectedCoupon[0].code_id,
              leastPrice: selectedCoupon[0].least_price * 100,
              threshold: selectedCoupon[0].least_price
            }
            setSelectedCoupon(coupon)
          } else {
            setSelectedCoupon(null)
          }
          hideCouponDialog()
        },
        needSelectedCoupons: callback => {
          if (selectedCoupon.value) {
            const coupon = {
              card_id: selectedCoupon.value?.cardId,
              batch_id: selectedCoupon.value?.batchId,
              code_id: selectedCoupon.value?.codeId
            }
            callback([coupon])
          }
        }
      }
    })
    reportUserAction({
      iformat: config.REPORT.CLICK.COUPON_SHOW
    })
  }
  return {
    availableCoupons,
    selectedCoupon,
    OpenCoupons
  }
}
